import { Row, Col, Form, Button, Modal } from 'react-bootstrap';
import "./InfoOrderModal.css";
import {  useState } from 'react';
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


const InfoOrderModal = ({ show, requestClose, orderID }) => {

    //ENV VARIABLE
    const apiUrl = process.env.REACT_APP_API_URL;
    const [waitingFlag, setWaitingFlag] = useState(false);

    const [objOrder, setObjOrder] = useState([]);


    const requestOrderInfo = async () =>{

        //
        setWaitingFlag(true);

        const endpoint = "getOrderByID?order_id=" + orderID;

        const response = await fetch(apiUrl + endpoint,
        {
            method: "GET",
            headers: {"Content-Type": "application/json"}
        });

        const responseContent = await response.json();

        const metadata = JSON.parse(responseContent.metadata);


        //
        setWaitingFlag(false);

        setObjOrder(metadata);


    } //END FUNCTION
    

    return (
        <>
        
        <Modal show={show} onShow={requestOrderInfo} onHide={requestClose} className={'mainOrderModal'}>
            <Modal.Header closeButton style={{borderTop:'10px solid #404661'}}>
                <Modal.Title className={'newOrderTitle'}>Información Orden de Servicio | <b style={{color:"darkred"}}>N° {orderID}</b></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>


                {waitingFlag ? 
                            <Row style={{textAlign:"center", color: "darkred"}}>
                                <Col>
                                    <FontAwesomeIcon 
                                        spin
                                        icon={faCircleNotch } 
                                        style={{}} 
                                    /> <span>Obteniendo datos, por favor espere...</span>
                                </Col>
                            </Row>
                            : 
                        (
                        <Row>

                            <Col xs={12} style={{lineHeight: '20px'}}>
                                
                                <span className='closeOrderlabels'>Cliente: </span>
                                <span>{objOrder.customer} </span><br />

                                <span className='closeOrderlabels'>Modelo: </span>
                                <span>{objOrder.model} </span><br />

                                <span className='closeOrderlabels'>N° Serie: </span>
                                <span>{objOrder.serialNumber}</span><br />

                                <span className='closeOrderlabels'>Falla / Detalles: </span>
                                <span>{objOrder.failure}</span><br />

                                <span className='closeOrderlabels'>Persona Contacto: </span>
                                <span>{objOrder.personContact}</span><br />

                                <span className='closeOrderlabels'>Dirección del servicio: </span>
                                <span>{objOrder.address}</span><br />

                                <span className='closeOrderlabels'>Datos de Contacto: </span>
                                <span>{objOrder.personContactData}</span><br />

                                <span className='closeOrderlabels'>Servicio Facturable: </span>
                                <span>{objOrder.serviceInvoice}</span><br />

                                <span className='closeOrderlabels'>Notas / Observaciones: </span>
                                <span>{objOrder.notes}</span><br />

                                <span className='closeOrderlabels'>Técnico: </span>
                                <span>{objOrder.tecnico}</span><br /><br />

                            </Col>
                            
                            {objOrder.technicalReport ? (
                                <div>
                                    <hr />
                                    <Col xs={12}>
                                        <Form.Group>
                                            <Form.Label className={'newOrderlabels'}>Informe Técnico</Form.Label>
                                            <Form.Control as="textarea" rows={5} disabled>{objOrder.technicalReport}</Form.Control><br />
                                        </Form.Group>
                                    </Col>
                                    <Row>
                                    <Col xs={6}>
                                        <Form.Group>
                                            <Form.Label className={'newOrderlabels'}>Contador Equipo</Form.Label>
                                            <Form.Control type="text" disabled value={objOrder.counterDevice} /><br />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={6}>
                                        <Form.Group>
                                            <Form.Label className={'newOrderlabels'}>Tipo de Servicio</Form.Label>
                                            <Form.Control type="text" disabled value={objOrder.serviceType} /><br />
                                        </Form.Group>
                                    </Col>
                                    </Row>
                                </div>
                            ) : ""}
                            

                            {objOrder.customerSignature ? (
                                <div>
                                    <hr />
                                    <Col xs={12}>
                                        <Form.Group>
                                            <Form.Label className={'newOrderlabels'}>Firma del Cliente</Form.Label>
                                            <div style={{border:"1px solid black", height:"150px"}}>
                                                <img src={`${objOrder.customerSignature}`} alt='firma cliente' />
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <br />

                                    <Row>
                                        <Col xs={6}>
                                            <Form.Group> 
                                                <Form.Label className={'newOrderlabels'}>Aclaración</Form.Label>
                                                <Form.Control 
                                                    type="text" 
                                                    placeholder="Aclaración" 
                                                    disabled
                                                    value={objOrder.signerName} />
                                            </Form.Group>
                                        </Col>
                                        
                                        <Col xs={6}>
                                            <Form.Group>
                                            <Form.Label className={'newOrderlabels'}>DNI</Form.Label>
                                            <Form.Control 
                                                type="text" 
                                                placeholder="DNI" 
                                                disabled
                                                value={objOrder.signerDNI} />
                                            </Form.Group>
                                        </Col>
                                    </Row>  
                                </div>
                            ) : ""}

                        </Row>
                    )}
                </Form>
            </Modal.Body>
            <Modal.Footer>
            <Button variant="danger" onClick={requestClose} size='sm'>
                Cerrar Ventana
            </Button>
            </Modal.Footer>
        </Modal>
        </>
    );
}

export default InfoOrderModal;